type Role = 'employer' | 'job_seeker' | 'admin';
type Verif = 'pending' | 'approved' | 'rejected' | null;

export function decideRoute(role: Role, onboardingDone: boolean | null, verif: Verif) {
  if (role === 'admin') return '/admin/overview';

  if (role === 'employer') {
    if (!onboardingDone) return '/employer/onboarding';
    if (verif !== 'approved') return '/employer/awaiting-approval';
    return '/employer/dashboard';
  }

  // candidate
  if (!onboardingDone) return '/job-seeker/onboarding';
  if (verif !== 'approved') return '/job-seeker/awaiting-approval';
  return '/job-seeker/dashboard';
}
